import { forwardRef } from "react";
import { cn } from "@/lib/cn";

const Input = forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-lg border border-m-divider bg-m-surface-light px-3 py-2 text-sm text-m-text placeholder:text-m-text-hint focus:outline-none focus:ring-2 focus:ring-m-primary focus:ring-offset-1 focus:ring-offset-m-bg disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
